import { createUserConstructor } from '@monorepo/auth';
import { getGrpcPromise } from '@monorepo/grpc';
import { CreateUserRequest } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';

import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';

const createUser = ({
  user,
  rawPassword
}: CreateUserRequest.AsObject): Promise<CreateUserRequest.AsObject | void> => {
  const request = new CreateUserRequest();

  if (rawPassword) {
    request.setRawPassword(rawPassword);
  }

  if (user) {
    const userInfo = createUserConstructor(user);
    request.setUser(userInfo);
  }

  return getGrpcPromise(WebAuthService.CreateUser)(request);
};

export default createUser;
